import { Injectable, Injector } from '@angular/core';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { LocalSourceOrigin } from './drivers/local-origin';
import { ISourceOriginDriver } from './drivers/source-origin-driver.interface';
import { VeevaSourceOrigin } from './drivers/veeva-origin';

@Injectable({
  providedIn: 'root',
})
export class GoToSourceService {
  private source: TSourceItem | undefined;

  constructor(private injector: Injector) {}

  private _driver: ISourceOriginDriver | undefined;

  get driver() {
    if (!this._driver || !this.source) throw new Error('Driver or Source is not set');
    return this._driver;
  }

  setSource(source: TSourceItem) {
    this.source = source;
    const originDriver = this.detectOrigin();
    this._driver = this.injector.get(originDriver);
    this.driver.setSource(source);
  }

  detectOrigin() {
    const metadata = this.source?.metadata;
    const hasVeevaId =
      Array.isArray(metadata) && metadata.some(it => it?.slug === 'veeva_id');
    if (hasVeevaId) {
      return VeevaSourceOrigin;
    }
    if (this.source?.fileLink) {
      return LocalSourceOrigin;
    }
    // Default to local origin if no specific type detected
    return LocalSourceOrigin;
  }

  hasSourceLink() {
    return this.driver.hasSourceLink(this.source!);
  }

  getSourceUrl() {
    return this.driver.getSourceUrl(this.source!);
  }
}
